import { render, staticRenderFns } from "./PortfolioCarousel.vue?vue&type=template&id=5499f372"
import script from "./PortfolioCarousel.vue?vue&type=script&lang=ts"
export * from "./PortfolioCarousel.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioCarousel.vue?vue&type=style&index=0&id=5499f372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports